import { RawAnchorTagData } from '@activebrands/core-web/libs/storyblok/storyblok';

type AnchorTagProp = RawAnchorTagData | RawAnchorTagData[] | undefined;

type TransformTagProps = {
    anchorTag: AnchorTagProp;
};

const transformAnchorTag = ({ anchorTag }: TransformTagProps): string | undefined => {
    if (!anchorTag || (Array.isArray(anchorTag) && !anchorTag?.[0])) {
        return;
    }

    const tagData = Array.isArray(anchorTag) ? anchorTag[0] : anchorTag;
    const { anchorTag: text } = tagData;

    return text;
};

export default transformAnchorTag;
